<i
    class="bi ms-2"
    [ngClass]="icon + ' ' + color"
    [title]="message | translate:{ date: (date | date:'shortDate') }"
    data-bs-toggle="tooltip" data-bs-placement="top"
></i>